<script setup lang="ts">
import { onMounted } from 'vue';

import { useChat } from '@/composables/useChat';
import phoneSvg from '@/icons/phone';

const { displayChatInfoText, initChat, isChatStatusPending, openChat } = useChat();

const chatSvg = nutshell['img/chat.svg'];

onMounted(initChat);
</script>

<template>
  <div class="text-sm" data-test="support-info-cart">
    <template v-if="!isChatStatusPending">
      <div v-if="displayChatInfoText" class="flex items-center justify-center gap-2">
        <img class="h-8" :src="chatSvg" alt="chat icon" />
        <div class="align-self-center">
          <div>Have a question?</div>
          <div class="underline cursor-pointer color-inherit" @click="openChat">
            Get help with Live Chat
          </div>
        </div>
      </div>
      <div v-else class="flex items-center justify-center">
        <div class="icon">
          <span class="telephone-icon" v-html="phoneSvg" />
        </div>
        <div class="align-self-center">
          Prefer to order by phone?
          <br />Call us at
          <b>
            <a href="tel:+1-800-558-6887" class="tel">800-558-6887</a>
          </b>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
$fontSize: 14px;
$itemHeight: $fontSize * 1.3;
$slotWidth: $itemHeight * 2;

.icon {
  width: $slotWidth;
  padding-top: 6px;
}
</style>
